/**
 * Prefixes spreadsheet formula characters so Excel and similar tools treat the cell as text.
 * Apply only to untrusted text fields; leave numeric cells (including negatives) unchanged.
 */
export function neutralizeCsvFormulaPrefix(value: string): string {
  if (/^[=+\-@\t\r]/.test(value)) {
    return `'${value}`;
  }
  return value;
}

/**
 * Escapes a single CSV field per RFC 4180 (quote when needed, double internal quotes).
 */
export function escapeCsvField(value: string): string {
  const needsQuotes = /[",\n\r]/.test(value);
  if (!needsQuotes) {
    return value;
  }
  return `"${value.replace(/"/g, '""')}"`;
}

/**
 * Serializes rows (including header row) to a CSV string with CRLF line endings.
 */
export function rowsToCsv(rows: string[][]): string {
  return rows.map((row) => row.map(escapeCsvField).join(",")).join("\r\n");
}

/**
 * Triggers a browser download of CSV content.
 */
export function downloadCsv(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(objectUrl);
}
